import { useEffect } from 'react'
import { WfmAbsence } from '../../../../services/actionsService'
import { SelectOption } from '../../../../services/dashboardService'

interface UseWfmAbsenceTypeAndReasonProps {
  wfmAbsence?: WfmAbsence
  absenceTypesList: SelectOption[]
  absenceReasonTypeList: SelectOption[]
  setAbsenceType: (type: SelectOption | undefined) => void
  setAbsenceReason: (reason: SelectOption | undefined) => void
}

const useWfmAbsenceTypeAndReason = ({
  wfmAbsence,
  absenceTypesList,
  absenceReasonTypeList,
  setAbsenceType,
  setAbsenceReason,
}: UseWfmAbsenceTypeAndReasonProps) => {
  useEffect(() => {
    if (!wfmAbsence || absenceTypesList.length === 0 || absenceReasonTypeList.length === 0) {
      return
    }

    if (wfmAbsence.absenceReasonTypeId) {
      const matchingReason = absenceReasonTypeList.find(
        reason => reason.value === wfmAbsence.absenceReasonTypeId
      )
      if (matchingReason) {
        setAbsenceReason(matchingReason)
      }
    }

    const notRequiredNotDisclosedId = 25
    const fallbackAbsencetypeId = wfmAbsence.absenceReasonTypeId === 1 ? notRequiredNotDisclosedId : 0

    const matchingType = absenceTypesList.find(type => 
      type.value === (wfmAbsence.absenceTypeId ?? fallbackAbsencetypeId)
    )

    setAbsenceType(matchingType)
  }, [wfmAbsence, absenceTypesList, absenceReasonTypeList, setAbsenceType, setAbsenceReason])
}

export default useWfmAbsenceTypeAndReason
